
import {
    Component,
    ElementRef,
    OnInit,
    OnDestroy,
} from '@angular/core';

@Component({
    selector: 'app-cs-ag-grid-popover-detail-renderer',
    templateUrl: './cs-ag-grid-popover-detail-renderer.component.html',
    styleUrls: ['./cs-ag-grid-popover-detail-renderer.component.scss'],
})
export class CsAgGridPopoverDetailRendererComponent implements OnInit, OnDestroy {
    data: any;
    params: any;
    popupEl: HTMLElement | null = null;
    popupHtml: string = '';
    showCommonFile: boolean = true;

    constructor(private el: ElementRef) {}

    ngOnInit(): void {
        this.data = this.params.data;
        if(this.params.activity){
            this.showCommonFile = false;
        }
    }

    onMouseEnter(event: MouseEvent): void {
        const content = this.data.recordType.toLowerCase();
        if (content !== 'job' && content !== 'opportunity') return;

        if (!this.popupEl) {
            // Call the API to fetch popup content when opening the popover
            if (this.params.popUpDetail) {
                this.popupHtml = this.params.popUpDetail(this.params.data);
            }

            this.popupEl = document.createElement('div');
            this.popupEl.classList.add('hover-popup-sched');
            this.popupEl.innerHTML = this.popupHtml;
            document.body.appendChild(this.popupEl);
        }

        const rect = (event.target as HTMLElement).getBoundingClientRect();
        const popupRect = this.popupEl.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        let top = rect.top + rect.height / 2 + window.scrollY - popupRect.height / 2;

        if (top < window.scrollY) {
            top = window.scrollY + 10;
        }

        if (top + popupRect.height > window.scrollY + viewportHeight) {
            top = window.scrollY + viewportHeight - popupRect.height - 10; // Add padding from the bottom
        }

        this.popupEl.style.position = 'absolute';
        this.popupEl.style.top = `${top}px`;
        this.popupEl.style.left = `${rect.right + 10 + window.scrollX}px`;
        this.popupEl.style.zIndex = '9999';

        const arrowEl = this.popupEl.querySelector('.arrow-left-sched') as HTMLElement;
        if (arrowEl) {
            const arrowOffset = event.clientY - top;
            arrowEl.style.top = `${arrowOffset}px`;
        }
    }

    onMouseLeave(): void {
        if (this.popupEl) {
            this.popupEl.remove();
            this.popupEl = null;
        }
    }

    ngOnDestroy(): void {
        if (this.popupEl) {
            this.popupEl.remove();
            this.popupEl = null;
        }
    }
}

